/**
 * An config containing properties for ngx-datatable
 *
 * For ngx-datatable options, see: https://swimlane.gitbooks.io/ngx-datatable/api/table/inputs.html
 */
var NgxDataTableConfig = /** @class */ (function () {
    function NgxDataTableConfig() {
    }
    return NgxDataTableConfig;
}());
export { NgxDataTableConfig };
//# sourceMappingURL=ngx-datatable-config.js.map